import { APP_USER_GROUPING_HISTORY_LIST_ROUTE } from 'config/route-consts';
import React from 'react'
import { Redirect, Route, Switch } from "react-router-dom";
import AppUserGroupingHistoryList from './AppUserGroupingHistoryList/AppUserGroupingHistoryList';

function AppUserGroupingHistoryView() {
    return (
        <Switch>
            <Route
                key={APP_USER_GROUPING_HISTORY_LIST_ROUTE}
                path={APP_USER_GROUPING_HISTORY_LIST_ROUTE}
                render={(props: any) => {
                    return <AppUserGroupingHistoryList {...props} />;
                }}
            />
            <Redirect to={APP_USER_GROUPING_HISTORY_LIST_ROUTE} />
        </Switch>
    );
}

export default AppUserGroupingHistoryView